import React from "react";
import config from "config";
import { Popover, Typography } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";

const CustomPopoverHoverBackground = styled(Typography).attrs()`
 .eui-option-inner{
  padding-top:12px ;
  padding-bottom:12px ;
 }
 .eui-option-inner:hover{
    background-color: ${(props) => props.theme.palette.light.c100};
},`;

const BulkGifting = ({ currency = "INR", typeformParams = "" }) => {
  const isINRClient = currency === "INR";
  const isUSDClient = currency === "USD";
  const data = [
    {
      title: "Prepaid Bank Cards",
      link:
        currency === "INR"
          ? `https://survey.typeform.com/to/pugVciaj`
          : `https://survey.typeform.com/to/OEiogPi8`,
      description: "Bank cards for Channel Partners",
    },
  ];
  isINRClient &&
    data.push({
      title: "Long Service Awards",
      link: `https://survey.typeform.com/to/YOllcZ8U`,
      description: "Reward years of service",
    });
  isINRClient &&
    data.push({
      title: "Employee Onboarding Kits",
      link: `https://survey.typeform.com/to/GPwEC1Yw`,
      description: " Welcome new hires",
    });
  isINRClient &&
    data.push({
      title: "Team Building",
      link: `https://survey.typeform.com/to/qp3vxjHu`,
      description: "Nurture Bonds Within Team",
    });
  isINRClient &&
    data.push({
      title: "Swag",
      link: `https://survey.typeform.com/to/r7O03MQd`,
      description: "Custom On-Demand Merchandise",
    });
  isUSDClient &&
    data.push({
      title: "Swag",
      link: `https://survey.typeform.com/to/UesBD6PF`,
      description: "Custom On-Demand Merchandise",
    });

  return (
    <div className="mr-28">
      {config.bulkGifting && (
        <div>
          <Popover
            trigger="hover"
            onOverlayClick={() => {}}
            onVisibilityChange={function noRefCheck() {}}
            content={
              <CustomPopoverHoverBackground className="mb-0">
                {data.map((element) => (
                  <Popover.Options>
                    <a
                      href={element.link}
                      target="_blank"
                      className="d-flex justify-content-between"
                      rel="noreferrer"
                    >
                      <Typography component="span">
                        <Typography
                          component="div"
                          color="dark"
                          shade="c300"
                          className="whitespace-nowrap text-left"
                        >
                          {element.title}
                        </Typography>
                        <Typography.BodySmall
                          color="dark"
                          shade="c200"
                          className="mb-0 text-left"
                        >
                          {element.description}
                        </Typography.BodySmall>
                      </Typography>
                    </a>
                  </Popover.Options>
                ))}
              </CustomPopoverHoverBackground>
            }
            placement="bottom-end"
            offset={[100, 0]}
            width={312}
            className="popover-placement"
          >
            <Typography.LabelText
              id={`bulk-gifting-title`}
              className="cursor-pointer"
              color="dark"
              shade="c200"
              component="div"
            >
              Bulk Gifting
            </Typography.LabelText>
          </Popover>
        </div>
      )}
    </div>
  );
};

export default BulkGifting;
